import { render, staticRenderFns } from "./milestone-plan-onboarding-dialog-content.vue?vue&type=template&id=a8926cde&"
import script from "./milestone-plan-onboarding-dialog-content.vue?vue&type=script&lang=ts&"
export * from "./milestone-plan-onboarding-dialog-content.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-plan-onboarding-dialog-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports